var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.info
        ? _c(
            "el-dialog",
            {
              staticClass: "DetailsDialog",
              attrs: {
                title: "是否确认认证？",
                visible: _vm.dialogVisible,
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                width: "40%",
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
                close: _vm.onHandleClose,
              },
            },
            [
              _c("div", { staticClass: "DetailsDialog-cnt" }, [
                _c("div", { staticClass: "list-item" }, [
                  _c("div", { staticClass: "list-item-left" }, [
                    _vm._v("认证类型："),
                  ]),
                  _c("div", { staticClass: "list-item-right" }, [
                    _vm._v(_vm._s(_vm.info.certification_type_txt)),
                  ]),
                ]),
                _c("div", { staticClass: "list-item" }, [
                  _c("div", { staticClass: "list-item-left" }, [
                    _vm._v("统一社会信息码："),
                  ]),
                  _c("div", { staticClass: "list-item-right" }, [
                    _vm._v(_vm._s(_vm.info.uscc)),
                  ]),
                ]),
                _c("div", { staticClass: "list-item" }, [
                  _c("div", { staticClass: "list-item-left" }, [
                    _vm._v("营业执照："),
                  ]),
                  _c(
                    "div",
                    { staticClass: "list-item-right" },
                    [
                      _c(
                        "el-image",
                        {
                          staticStyle: { width: "100px", height: "100px" },
                          attrs: {
                            src: _vm.info.license.img,
                            "preview-src-list": [_vm.info.license.img],
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "image-slot",
                              attrs: { slot: "error" },
                              slot: "error",
                            },
                            [_vm._v(" 暂无数据 ")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "list-item" }, [
                  _c("div", { staticClass: "list-item-left" }, [
                    _vm._v(
                      _vm._s(
                        _vm.info.certification_type != 10
                          ? "法人姓名："
                          : "持卡人姓名："
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "list-item-right" }, [
                    _vm._v(_vm._s(_vm.info.idcard_name)),
                  ]),
                ]),
                _c("div", { staticClass: "list-item" }, [
                  _c("div", { staticClass: "list-item-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.info.certification_type != 10
                            ? "法人身份证号："
                            : "持卡人身份证号："
                        )
                    ),
                  ]),
                  _c("div", { staticClass: "list-item-right" }, [
                    _vm._v(_vm._s(_vm.info.idcard_code)),
                  ]),
                ]),
                _c("div", { staticClass: "list-item" }, [
                  _c("div", { staticClass: "list-item-left" }, [
                    _vm._v(
                      _vm._s(
                        _vm.info.certification_type != 10
                          ? "法人手机号码："
                          : "银行预留电话："
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "list-item-right" }, [
                    _vm._v(_vm._s(_vm.info.manage_mobile)),
                  ]),
                ]),
                _c("div", { staticClass: "list-item" }, [
                  _c("div", { staticClass: "list-item-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.info.certification_type != 10
                            ? "法人身份证国徽页："
                            : "持卡人身份证国徽页："
                        )
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "list-item-right" },
                    [
                      _c(
                        "el-image",
                        {
                          staticStyle: { width: "100px", height: "100px" },
                          attrs: {
                            src: _vm.info.idcard_a,
                            "preview-src-list": [_vm.info.idcard_a],
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "image-slot",
                              attrs: { slot: "error" },
                              slot: "error",
                            },
                            [_vm._v(" 暂无数据 ")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "list-item" }, [
                  _c("div", { staticClass: "list-item-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.info.certification_type != 10
                            ? "法人身份证人像页："
                            : "持卡人身份证人像页："
                        )
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "list-item-right" },
                    [
                      _c(
                        "el-image",
                        {
                          staticStyle: { width: "100px", height: "100px" },
                          attrs: {
                            src: _vm.info.idcard_b,
                            "preview-src-list": [_vm.info.idcard_b],
                            alt: "",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "image-slot",
                              attrs: { slot: "error" },
                              slot: "error",
                            },
                            [_vm._v(" 暂无数据 ")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "list-item" }, [
                  _c("div", { staticClass: "list-item-left" }, [
                    _vm._v("所属银行："),
                  ]),
                  _c("div", { staticClass: "list-item-right" }, [
                    _vm._v(_vm._s(_vm.info.supplier_bank.bank_name)),
                  ]),
                ]),
                _c("div", { staticClass: "list-item" }, [
                  _c("div", { staticClass: "list-item-left" }, [
                    _vm._v("开户行："),
                  ]),
                  _c("div", { staticClass: "list-item-right" }, [
                    _vm._v(_vm._s(_vm.info.supplier_bank.bank_deposit)),
                  ]),
                ]),
                _c("div", { staticClass: "list-item" }, [
                  _c("div", { staticClass: "list-item-left" }, [
                    _vm._v("卡号："),
                  ]),
                  _c("div", { staticClass: "list-item-right" }, [
                    _vm._v(_vm._s(_vm.info.supplier_bank.card_code)),
                  ]),
                ]),
              ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("el-button", { on: { click: _vm.onHandleClose } }, [
                    _vm._v("关闭"),
                  ]),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.qr } },
                    [_vm._v("认证")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }